import React from 'react';

const HeaderTopPlaceholder = () => {
    return <div className='tb--placeholder header--top-placeholder header-block_holder menu--block-item tb--flex tb--align-center tb--w_100 tb--show-animation no-mutation'>
        <div className='tb--flex tb--align-center tb--w_100'>
            <div className='header--logo-placeholder'></div>
            <div className='header--menus tb--mobile-hide tb--flex tb--w_100'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>

        <div className='header--actions tb--flex tb--align-center'>
            <div></div>
            <div></div>
        </div>
    </div>
}
const InlineLoginPlaceholder = () => {
    return <div className='tb--flex tb--align-center tb--show-animation inline-placeholder'>
        <div className='inline-first'></div>
        <div className='inline-second tb--mh-10'></div>
        <div className='inline-third'></div>
    </div>
}
export { HeaderTopPlaceholder, InlineLoginPlaceholder }